/// <amd-module name="Search/WorkItem/Flux/Stores/NotificationStore" />

import * as VSSStore from "VSS/Reflux/Store";
import { ErrorData } from "Search/LegacyWebApi/Contracts/Search.SharedLegacy";
import { IndexingErrorCodeConstants } from "Search/WorkItem/Constants";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { WorkItemSearchResponse, WorkItemResult } from "Search/LegacyWebApi/Contracts/WorkItem";

export interface INotificationStoreState {
    indexingBannerState: IndexingBanner;
}

export enum IndexingBanner {
    AccountIndexing,
    None
}

export class NotificationStore extends VSSStore.Store {
    protected _state: INotificationStoreState;

    constructor(changedEventName: string, data?: ISeedData<WorkItemResult>) {
        super(changedEventName);
        this._state = {
            indexingBannerState: data && data.responseWithActivityId ? this.getState(data.responseWithActivityId.response as WorkItemSearchResponse) : IndexingBanner.None
        };
    }

    public get state(): INotificationStoreState {
        return this._state;
    }

    public onSearchResultsLoaded = (payload: IResultsLoadedPayload<WorkItemSearchResponse, WorkItemResult>): void => {
        this._state.indexingBannerState = this.getState(payload.response);
        this.emitChanged();
    }

    private getState = (response: WorkItemSearchResponse): IndexingBanner => {
        if (response && response.errors.length > 0) {
            const isIndexingScenario: boolean = this.check(response.errors,
                IndexingErrorCodeConstants.AccountIsBeingIndexed,
                IndexingErrorCodeConstants.AccountIsBeingReindexed);

            if (isIndexingScenario) {
                return IndexingBanner.AccountIndexing;
            }
        }
        return IndexingBanner.None;
    }

    private check(errors: ErrorData[], ...args: string[]): boolean {
        return errors
            .some(e => args.some((arg: string) => e.errorCode === arg));
    }
}